module.exports = "http://cheyintong-website.oss-cn-beijing.aliyuncs.com/img/pexels-albin-berlin-919073@2x.png";